import { useQuery } from "react-query";
import { searchOfficeSettings } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useSearchOfficeSettings = ({
  searchInputsData,
  enableSearch = false,
}) => {
  return useQuery(
    ["SearchOfficeSettings", searchInputsData],
    searchOfficeSettings,
    {
      enabled: enableSearch,
    }
  );
};

export default useSearchOfficeSettings;
